import { loginRequest, graphConfig } from '../authConfig'
import { msalInstance } from '../index'
import { appInsights } from 'config/appInsights'

export async function callMsGraph() {
  const accessToken = await getAuthInfo()

  const headers = new Headers()
  const bearer = `Bearer ${accessToken}`

  headers.append('Authorization', bearer)

  const options = {
    method: 'GET',
    headers
  }

  return fetch(graphConfig.graphMeEndpoint, options)
    .then(response => response.json())
    .catch(error => appInsights.trackException(error))
}

export async function getAuthInfo() {
  const account = msalInstance.getActiveAccount()
  if (!account) {
    loginRedirect()
    throw Error(
      'No active account! Verify a user has been signed in and setActiveAccount has been called.'
    )
  }

  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account
  })

  return response
}

export async function loginRedirect() {
  msalInstance.loginRedirect(loginRequest)
}
